import type { Summary } from "../api/models";

export function pct(n: number, d: number): string {
  if (d === 0) return "—";
  return `${((100 * n) / d).toFixed(1)}%`;
}

export function accuracy(summary: Summary | null): { correct: string; verified: string } {
  if (!summary) return { correct: "—", verified: "—" };
  return {
    correct: pct(summary.correct, summary.scored),
    verified: pct(summary.verifiedCorrect, summary.verified),
  };
}
